import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountmanagementRoutingModule } from './accountmanagement-routing.module';
import { AccounthomeComponent } from './accounthome.component';
import { SharedModule } from '../../shared/shared/shared.module';
import { UpdatepasswordComponent } from './components/updatepassword/updatepassword.component';
import { AppfilesComponent } from './components/appfiles/appfiles.component';
import { UserserviceService } from './services/userservice.service'

@NgModule({
  declarations: [AccounthomeComponent, UpdatepasswordComponent, AppfilesComponent],
  imports: [
    SharedModule,
    CommonModule,
    AccountmanagementRoutingModule,

  ],
  providers: [UserserviceService]
})
export class AccountmanagementModule { }
